// extracted by css-extract-rspack-plugin
export default {"initInstructions":"H3_mnZPuOFkKuDC1"};